import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    minHeight: 24,
    minWidth: 24,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    fontSize: '0.85em',
    lineHeight: '1.2em',
    '&::before': {
      shapeOutside: 'circle()',
    },
  },
}));

export default function CircleWithCount({ count, className }) {
  const classes = useStyles();
  return (
    <Box component="span" className={classNames(classes.root, { [className]: Boolean(className) })}>{count}</Box>
  );
}

CircleWithCount.defaultProps = {
  className: undefined,
};

CircleWithCount.propTypes = {
  count: PropTypes.number.isRequired,
  className: PropTypes.string,
};
